export default "__VITE_ASSET__CbF13jo0__"